export default __webpack_public_path__ + "static/media/balmain_8.29a41a6c.jpg";